export default {
    addPlayer(state, payload) {
        state.commit('appendPlayer', payload);
        state.commit('logData', payload);
    },
    delPlayer(state, payload) {
        state.commit('removePlayer', payload);
        state.commit('logData', payload);
    },
    updChunck(state, payload) {
        state.commit('updateWordChunck', payload);
        state.commit('logData', payload);
    },

    setTime(state, payload) {
        state.commit('setTimer', payload);
        state.commit('logData', payload);
    },
    setCountForWiner(state, payload) {
        state.commit('setCountForWin', payload);
        state.commit('logData', payload);
    },

    updPlayerImg(state, payload) {
        state.commit('updatePlayerImage', payload);
        state.commit('logData', payload);
    },
    updPlayerTitle(state, payload) {
        state.commit('updatePlayerTitle', payload);
        state.commit('logData', payload);
    },
    addUsedWord(state, payload) {
        state.commit('appendUsedWord', payload);
        state.commit('logData', payload);
    },
    addResolvedWord(state, payload) {
        state.commit('appendResolvedWord', payload);
        state.commit('logData', payload);
    },
    addUnresolvedWord(state, payload) {
        state.commit('appendUnresolvedWord', payload);
        state.commit('logData', payload);
    },
    changePlayer(state, payload) {
        state.commit('nextPlayer', payload);
        state.commit('logData', payload);
    },
    updWord(state, payload) {
        state.commit('wordSet', payload);
        state.commit('logData', payload);
    },
    detectWin(state, payload) {
        state.commit('detectWinner', payload);
        state.commit('logData', payload);
    },
    loadingData(state, payload) {
        state.commit('loadData', payload);
    },
    cleanAllData(state, payload) {
        state.commit('cleanData', payload);
        state.commit('loadData', payload);
        state.commit('logData', payload);
    },
}
